export default "__VITE_ASSET__ClvBPxbJ__"